import { Box, CardMedia, LinearProgress, Modal, Typography } from '@mui/material'
import React, { useState } from 'react'
import TaskOutlinedIcon from '@mui/icons-material/TaskOutlined'
import loadingState from '../../../../../assets/images/loading_state.png'
import AdxButton from 'components/custom/AdxButton'

const SubmissionModal = ({ handleSubmit, disabled, isLoading }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleClose = () => {
    setIsModalOpen(false)
  }

  const onSubmit = () => {
    handleSubmit()
    handleClose()
  }

  return (
    <React.Fragment>
      <AdxButton
        variant={'contained'}
        onClick={() => setIsModalOpen(true)}
        disabled={disabled}
        size={'small'}
        sx={{ width: '150px' }}
      >
        Submit
      </AdxButton>
      <Modal
        open={isModalOpen}
        onClose={handleClose}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            width: '550px',
            backgroundColor: 'white.main',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderRadius: '4.5px',
            padding: '32px',
            gap: '32px',
          }}
        >
          <Box
            sx={{
              width: '90px',
              height: '90px',
              backgroundColor: 'gray-background.main',
              borderRadius: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <TaskOutlinedIcon sx={{ height: '40px', width: '40px', color: 'alternate.main' }} />
          </Box>
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="h4" mb={'8px'}>
              Confirm action
            </Typography>
            <Typography color={'light-gray-text.main'}>
              Are you sure you want to submit this test? After submission, it will no longer be
              possible to modify your answer.
            </Typography>
          </Box>
          <Box sx={{ width: '100%' }}>
            <AdxButton variant={'contained'} onClick={onSubmit} sx={{ width: '100%', mb: '8px' }}>
              Confirm
            </AdxButton>
            <AdxButton variant={'ghost'} onClick={handleClose} sx={{ width: '100%' }}>
              Cancel
            </AdxButton>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={isLoading}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            width: '550px',
            backgroundColor: 'white.main',
            borderRadius: '4.5px',
            padding: '32px 24px',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <CardMedia
            component="img"
            sx={{
              width: '141px',
              height: '121px',
              objectFit: 'cover',
              marginBottom: '26px',
            }}
            src={loadingState}
          />
          <Typography variant="h4" mb={'16px'}>
            Calculating your result..
          </Typography>
          <Typography color="light-gray-text.main">
            Please wait a moment. We're currently analyzing your answer to determine your work
            personality.
          </Typography>
          <LinearProgress
            variant="indeterminate"
            sx={{
              width: '100%',
              height: '5px',
              marginTop: '52px',
              '.MuiLinearProgress-barColorPrimary': { backgroundColor: 'alternate.main' },
              backgroundColor: 'alternate.light',
            }}
          />
        </Box>
      </Modal>
    </React.Fragment>
  )
}

export default SubmissionModal
